import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  content: {
    display: 'flex',
    flexFlow: 'column nowrap',
  },

  trainingTest: {
    display: 'flex',
    flex: '1',
  },

  list: {
    flex: '1',
    display: 'flex',
    flexFlow: 'column nowrap',
  },

  sidePanel: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '20rem',
    marginLeft: '2.5rem',
    position: 'relative',
  },

  scoreInfoButton: {
    position: 'absolute',
    marginLeft: '298px',
    marginTop: '-4px',
  },

  chartContainer: {
    marginTop: '1rem',
  },

  chartHeader: {
    textAnchor: 'middle',
    fill: 'currentColor',
    fontSize: '.7rem',
    color: t.primary,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    marginRight: '0.6rem',
    marginTop: '.7rem',
    textTransform: 'uppercase',
  },

  histogramHeader: {
    display: 'flex',
  },

  table: {
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: '0.875rem',
    marginBottom: '1rem',
  },

  th: {
    textAlign: 'left',
    padding: '0.5rem',
    borderBottom: '1px solid #ddd',
  },

  td: {
    padding: '0.5rem',
  },

  paddingLeft: {
    paddingLeft: '1rem',
  },

  indented: {
    marginTop: '10px',
    marginLeft: '30px',
  },
}))

export default useStyles
